export const endsWithAnyOf = (subject, possibleMatches) => (subject === ''
    ? possibleMatches
    : possibleMatches.filter(possibleMatch => possibleMatch !== '')).some(possibleMatch => subject.endsWith(possibleMatch));
//# sourceMappingURL=endsWithAnyOf.js.map